import React from 'react';

const ITeamMonitoring = () => {
  return (
    <>
        <svg id="Flat" xmlns="http://www.w3.org/2000/svg" width="18.232" height="18" viewBox="0 0 24 18">
        <g id="Group_5992" data-name="Group 5992">
            <g id="Group_5988" data-name="Group 5988" transform="translate(17.095 10.271)">
            <path id="Path_9431" data-name="Path 9431" d="M16.67,13.13a5.259,5.259,0,0,1,2.542,4.354v3.375h3.273a1.112,1.112,0,0,0,1.091-1.125v-2.25C23.575,15.031,19.681,13.58,16.67,13.13Z" transform="translate(-16.67 -13.13)" ffill-rule="evenodd"/>
            </g>
            <g id="Group_5989" data-name="Group 5989" transform="translate(4.364)">
            <ellipse id="Ellipse_755" data-name="Ellipse 755" cx="4.364" cy="4.5" rx="4.364" ry="4.5" />
            </g>
            <g id="Group_5990" data-name="Group 5990" transform="translate(13.822)">
            <path id="Path_9432" data-name="Path 9432" d="M15.121,13a4.432,4.432,0,0,0,4.364-4.5A4.315,4.315,0,0,0,13.67,4.27a6.892,6.892,0,0,1,0,8.46A4.435,4.435,0,0,0,15.121,13Z" transform="translate(-13.67 -4)" ffill-rule="evenodd"/>
            </g>
            <g id="Group_5991" data-name="Group 5991" transform="translate(0 10.125)">
            <path id="Path_9433" data-name="Path 9433" d="M9.727,13C6.815,13,1,14.507,1,17.5v2.25a1.112,1.112,0,0,0,1.091,1.125H17.364a1.112,1.112,0,0,0,1.091-1.125V17.5C18.455,14.507,12.64,13,9.727,13Z" transform="translate(-1 -13)" ffill-rule="evenodd"/>
            </g>
        </g>
        </svg>
    </>
  )
};

export default ITeamMonitoring;
